<template>

</template>

<script>
  export default {
    name: 'vSettings',
  };
</script>

<style scoped>

</style>
